/**
 * Pricing 对话框配置常量
 */
export const PRICING_CONFIG = {
    /** 默认对话框宽度 */
    DEFAULT_WIDTH: '1200px',

    /** 默认对话框高度 */
    DEFAULT_HEIGHT: 'auto',
} as const;
